import { AuthService, ProvidedAuthData } from '_platform';
import { AuthenticateData, AuthUserCreate } from 'graphql/AuthQueries';
import { APP_BASENAME } from 'index';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const REMEMBER_ME_COOKIE = 'rememberMe';

export interface CookieAuthService extends AuthService {
  provideAuthData(): Promise<CookieProvidedAuthData | null>
}

export interface CookieProvidedAuthData extends ProvidedAuthData {
}

const storeAuthData = (data: AuthenticateData) => {
  
  if (data?.rememberMe) {console.log("set remember", data.rememberMe)
    cookies.set(REMEMBER_ME_COOKIE, data.rememberMe, { path: '/' + APP_BASENAME + '/', maxAge: 3600, secure: true, sameSite: 'none'  });
    return true;
  }
  return false;
}

const provideAuthData = (): Promise<CookieProvidedAuthData | null> => {
  const rememberMeToken = cookies.get(REMEMBER_ME_COOKIE);

  return new Promise(function(resolve, reject) {
    if(!rememberMeToken){
      resolve(null);
    }else{
      setTimeout(function() {
        resolve({type: REMEMBER_ME_COOKIE, token: rememberMeToken});
      }, 300);
    }
  })
}

const provideAuthUserCreate = (): Promise<AuthUserCreate | undefined> => {
  return new Promise(function(resolve, reject) {
    try {
      // Language and locale (e.g., "en-US")
      const locale = navigator.language || 'en-US'

      // Extract language ("en") and country ("US") if available
      const [language, countryCode] = locale.split('-')

      // Timezone (e.g., "Europe/Bratislava")
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      resolve({
        locale,
        language,
        countryCode,
        timezone
      })
    } catch (err) {
      console.error("Error detecting browser settings", err)
      resolve({})
    }
  })
}

const connectionRequired = () => {
  return false;
}

const deleteAuthData = () => {
  cookies.remove(REMEMBER_ME_COOKIE, { path: '/' + APP_BASENAME + '/' });
}

const cookieAuthService = {
  provideAuthData, connectionRequired, storeAuthData, deleteAuthData, provideAuthUserCreate
};
export default cookieAuthService;